import React__default from 'react';
import classNames from 'classnames';
import styles from './MenuSection.module.esm.js';

var MenuSection = function (_a) {
    var title = _a.title, children = _a.children, className = _a.className;
    return (React__default.createElement("li", { className: classNames(styles.sectionHeader, className), "data-testid": "nav-menu-section" },
        title && React__default.createElement("p", { className: classNames(styles.title, 'nv-subheading-2') }, title),
        React__default.createElement("ul", null, children)));
};

export { MenuSection, MenuSection as default };
//# sourceMappingURL=MenuSection.esm.js.map
